import {
  DateInputRenderer,
  type DateInputRendererProps,
  getRendererProps,
  NumberInputRenderer,
  type TextFieldRendererProps,
  TimeInputRenderer,
  type TimeInputRendererProps,
} from '@exam-center/components';
import { Box, Flex, Grid, Text } from '@shared/components';

export interface ExamSessionInformationFieldsProps {
  fields: {
    examRound: TextFieldRendererProps;
    examDate: DateInputRendererProps;
    examStartTime: TimeInputRendererProps;
    examEndTime: TimeInputRendererProps;
  };
}

export default function ExamSessionInformationFields(
  props: Readonly<ExamSessionInformationFieldsProps>,
) {
  const { fields } = props;

  return (
    <Flex sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(6) })}>
      <Flex sx={(theme) => ({ gap: theme.spacing(6) })}>
        <Text variant='body1Semibold' sx={{ flexBasis: '240px' }}>
          รอบสอบ
        </Text>
        <NumberInputRenderer
          {...getRendererProps(fields.examRound, {
            label: 'รอบที่สอบ',
            placeholder: 'ระบุรอบที่สอบ',
            sx: { maxWidth: '200px' },
          })}
        />
      </Flex>
      <Flex sx={(theme) => ({ gap: theme.spacing(6) })}>
        <Text variant='body1Semibold' sx={{ flexBasis: '240px' }}>
          วันที่และเวลาสอบ
        </Text>
        <Grid
          sx={(theme) => ({
            gridTemplateColumns: '200px 1fr 200px',
            placeItems: 'flex-end',
            rowGap: theme.spacing(4),
            columnGap: theme.spacing(2),
          })}
        >
          <DateInputRenderer
            {...getRendererProps(fields.examDate, {
              label: 'วันที่สอบ',
              inputFormat: 'DD-MM-YYYY',
              placeholder: 'DD-MM-YYYY',
              sx: { width: '200px' },
            })}
          />
          {/* REMARK: The Box is used to force the TimeInputRenderer to occupy full width of the grid
          column since TimeInputRenderer does not accept sx props. */}
          <Box sx={{ gridColumn: '1', width: '100%' }}>
            <TimeInputRenderer
              {...getRendererProps(fields.examStartTime, {
                label: 'เวลาเริ่มต้น',
              })}
            />
          </Box>
          <Text
            component='span'
            sx={(theme) => ({
              pb: theme.spacing(3.5),
              px: theme.spacing(1),
              minWidth: 'fit-content',
            })}
          >
            ถึง
          </Text>
          <TimeInputRenderer
            {...getRendererProps(fields.examEndTime, {
              label: 'เวลาสิ้นสุด',
              sx: {
                minWidth: '200px',
              },
            })}
          />
        </Grid>
      </Flex>
    </Flex>
  );
}
